import React from 'react';
import { createPortal } from 'react-dom';

import { useModal } from '../context';
import { useHydration } from 'utils/hooks';

export default function ModalActionsPortal({ children = null }) {
  const isHydrated = useHydration();

  const { footerId } = useModal();

  if (!isHydrated) return null;

  return createPortal(<>{children}</>, document.getElementById(footerId));
}
